import http from './http'

export const loginApi = (username, password) =>
  http.post('/admin/login', { username, password })

export const adminApi = {
  overview: () => http.get('/admin/overview'),
  users: (params = {}) => http.get('/admin/users', { params }),
  userDetail: (id) => http.get(`/admin/users/${id}`),
  userProfile360: (id) => http.get(`/admin/users/${id}/profile`),
  resetUserPassword: (id) => http.post(`/admin/users/${id}/reset-password`),
  reports: (params = {}) => http.get('/admin/reports', { params }),
  reportDetail: (id) => http.get(`/admin/reports/${id}`),
  ticketKpi: (params = {}) => http.get('/admin/tickets/kpi', { params }),
  ticketAlerts: (params = {}) => http.get('/admin/tickets/alerts', { params }),
  ticketAlertHistory: (params = {}) => http.get('/admin/tickets/alerts/history', { params }),
  ticketOpsConfig: () => http.get('/admin/tickets/ops/config'),
  ticketOpsConfigUpdate: (payload) => http.post('/admin/tickets/ops/config', payload),
  ticketOpsReload: () => http.post('/admin/tickets/ops/reload'),
  ticketOpsRuns: (params = {}) => http.get('/admin/tickets/ops/runs', { params }),
  ticketOpsRun: (payload) => http.post('/admin/tickets/ops/run', payload),
  ticketAutoEscalate: (payload) => http.post('/admin/tickets/auto-escalate', payload),
  ticketList: (params = {}) => http.get('/admin/tickets', { params }),
  ticketDetail: (id) => http.get(`/admin/tickets/${id}`),
  ticketCreate: (payload) => http.post('/admin/tickets', payload),
  ticketAssign: (id, payload) => http.post(`/admin/tickets/${id}/assign`, payload),
  ticketSetPriority: (id, payload) => http.post(`/admin/tickets/${id}/priority`, payload),
  ticketResolve: (id, payload) => http.post(`/admin/tickets/${id}/resolve`, payload),
  orderList: (params = {}) => http.get('/admin/orders', { params }),
  compensateSubscription: (payload) => http.post('/admin/subscriptions/compensate', payload),
  auditLogs: (params = {}) => http.get('/admin/audit/logs', { params }),
  fortuneSubscriptionMetrics: (params = {}) => http.get('/admin/fortune/subscription/metrics', { params }),
  fortuneSubscriptionFunnel: (params = {}) => http.get('/admin/fortune/subscription/funnel', { params }),
  fortuneSubscriptionTrend: (params = {}) => http.get('/admin/fortune/subscription/trend', { params })
}
